import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconNoConnection$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconNoConnection extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ecc1510c27a9a7db88a680a8aa675c05aa5d2f13', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ba6a5a48f2bc5e129dbf863aa8363ff4081079f9', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ed77548b19729a63bbbccc0298c2fb8e0ed280a5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.515 3.146a.51.51 0 0 1 .717 0l5.04 5.04a9.55 9.55 0 0 1 6.848 2.424.53.53 0 0 1 .007.758l-.368.368a.51.51 0 0 1-.713.007 8 8 0 0 0-4.14-1.922l7.947 7.946a.52.52 0 0 1 0 .727l-.359.359a.52.52 0 0 1-.727 0L4.147 4.233a.51.51 0 0 1 0-.718zm-.153 7.464a9.6 9.6 0 0 1 2.522-1.625l1.203 1.202a8 8 0 0 0-2.658 1.564.54.54 0 0 1-.729-.008l-.368-.367a.53.53 0 0 1 .03-.766m2.392 2.406a6.3 6.3 0 0 1 2.83-1.332l1.422 1.423a4.7 4.7 0 0 0-3.185 1.05.53.53 0 0 1-.721-.015l-.368-.368a.52.52 0 0 1 .022-.758m5.458 2.384a2.95 2.95 0 0 0-2.943 0 .52.52 0 0 0-.081.802l1.184 1.184a.53.53 0 0 0 .743-.007l1.178-1.177a.51.51 0 0 0-.081-.802", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-no-connection", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-no-connection"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-no-connection":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconNoConnection$1);
            }
            break;
    } });
}

const CosmosIconNoConnection = CosmosIconNoConnection$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconNoConnection, defineCustomElement };
